var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { AchooTextFieldComponent } from '../../core/achoo-text-field/achoo-text-field.component';
import { Observable } from 'rxjs/Observable';
import { StringUtils } from '../../utils/string.utils';
import { AchooTabsComponent } from '../../core/achoo-tabs/achoo-tabs.component';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { CampaignCustomTerm } from '../../../models/campaign';
import { FileAction } from './upload-file/upload-file.component';
import { CommonConstant } from '../../app.constants';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { Page, UserActionType, ActivePages, ActionSource, TargetType, ActionDetails } from '../../services/event-tracker/event-tracker.service';
import { InvalidAction } from '../../../models/user';
import { CampaignInfluencerStatus as CampaignStatus } from '../../app.constants';
import { DateUtils } from '../../utils/date.utils';
var TermRegex = /{{([^}}]+)?}}/g;
export var CampaignTab;
(function (CampaignTab) {
    CampaignTab["TERMS"] = "terms";
    CampaignTab["INFLUENCER"] = "influencers";
    CampaignTab["MATERIALS"] = "materials";
})(CampaignTab || (CampaignTab = {}));
export var CampaignType;
(function (CampaignType) {
    CampaignType["CREATION"] = "CAMPAIGN_CREATION";
})(CampaignType || (CampaignType = {}));
/**
 * Define several action type for Term
 */
export var TermActionType;
(function (TermActionType) {
    TermActionType["ADD"] = "add";
    TermActionType["EDIT"] = "edit";
    TermActionType["DELETE"] = "delete";
})(TermActionType || (TermActionType = {}));
/**
 * Define several status of campaign influencer
 */
export var CampaignInfluencerStatus;
(function (CampaignInfluencerStatus) {
    CampaignInfluencerStatus["NEW"] = "new";
    CampaignInfluencerStatus["INVITED"] = "invited";
    CampaignInfluencerStatus["ACCEPTED"] = "accepted";
})(CampaignInfluencerStatus || (CampaignInfluencerStatus = {}));
var CampaignsDetailComponent = /** @class */ (function (_super) {
    __extends(CampaignsDetailComponent, _super);
    function CampaignsDetailComponent(router, activatedRoute, translate, campaignService, groupService, userService, mentionService, modalService, validateErrorHandler, referenceDataService, eventTracker, cacheService, defaultCampaignName) {
        var _this = _super.call(this, userService) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.campaignService = campaignService;
        _this.groupService = groupService;
        _this.userService = userService;
        _this.mentionService = mentionService;
        _this.modalService = modalService;
        _this.validateErrorHandler = validateErrorHandler;
        _this.referenceDataService = referenceDataService;
        _this.eventTracker = eventTracker;
        _this.cacheService = cacheService;
        _this.defaultCampaignName = defaultCampaignName;
        _this.campaignName = '';
        _this._mentions = [];
        _this.currentInputMention = '';
        _this.campaignBrief = '';
        _this.campaignAdditionalInfo = '';
        _this.selectableCampaignTerms = [];
        _this.materialImages = [];
        _this.campaignInfluencers = [];
        _this.tabKey = CampaignTab.TERMS;
        _this.currentDeleteMentionIndex = -1;
        // use for bottom bar
        _this.isShowAddInfluencerToCampaignsFragment = false;
        _this.isShowAddInfluencerManuallyFragment = false;
        _this.isShowModifyCustomTerm = false;
        // reference data
        _this.supportedCountryList = [];
        _this.supportedPlatformList = [];
        _this.canCreateOrEditCampaign = true;
        _this.processingMentions = [];
        _this.isFetchingInfluencer = false;
        _this.isDirtyCampaignData = false;
        // on error because of invalid account level
        _this.hasInvalidAccountLevelError = false;
        _this.exportLabel = _this.translate.instant('campaigns.export_xls_campaign_name_btn');
        _this.campaignName = defaultCampaignName || '';
        return _this;
    }
    /**
     * @param error
     * @param translate
     * @returns {any}
     */
    CampaignsDetailComponent.buildMessageErrorInArchive = function (error, translate) {
        if (!error || error.error_code !== 'invalid_account_level' || !error.data) {
            return {
                errorMsg: translate.instant('campaigns.unarchive_campaign_unexpect_error'),
                errorType: 'server error'
            };
        }
        var errorData = error.data;
        var availableSlots = errorData.availableSlots;
        if (availableSlots <= 0) {
            return {
                errorMsg: translate.instant('campaigns.unarchive_campaign_error_message', {
                    maxValue: errorData.maxSlots
                }),
                errorType: 'invalid level'
            };
        }
        return {
            errorMsg: translate.instant('campaigns.unarchive_campaign_exceed_limit', {
                actualValue: errorData.addingSlots,
                maxValue: errorData.availableSlots
            }),
            errorType: 'invalid level'
        };
    };
    CampaignsDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params.isCampaignHistory) {
                _this.isCampaignHistory = params.isCampaignHistory;
            }
            if (params.isCampaignInfluencer) {
                _this.isCampaignInfluencer = params.isCampaignInfluencer;
            }
        });
        _super.prototype.ngOnInit.call(this);
        this.supportedCountryList = this.referenceDataService.countries;
        this.supportedPlatformList = this.referenceDataService.platforms;
    };
    CampaignsDetailComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.sub) {
            this.sub.unsubscribe();
        }
    };
    CampaignsDetailComponent.prototype.getSelectedTermCampaign = function (companyId) {
        var _this = this;
        this.campaignService.getSelectableCampaignTerms(companyId, 'CAMPAIGN_CREATION').subscribe(function (terms) {
            terms.forEach(function (x) {
                x.params = _this.parseTerm(x);
                x.selected = false;
                x.companyId = companyId;
            });
            _this.selectableCampaignTerms = terms;
        });
    };
    Object.defineProperty(CampaignsDetailComponent.prototype, "mentions", {
        get: function () {
            return this._mentions.map(function (x) { return x.keyword; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsDetailComponent.prototype, "selectedCampaignTerms", {
        get: function () {
            return this.selectableCampaignTerms.filter(function (x) {
                return x.selected;
            });
        },
        enumerable: true,
        configurable: true
    });
    CampaignsDetailComponent.prototype.saveAndSend = function () {
        if (this.tabKey === CampaignTab.TERMS) {
            this.tabKey = CampaignTab.INFLUENCER;
        }
        else if (this.tabKey === CampaignTab.INFLUENCER) {
            this.tabKey = CampaignTab.MATERIALS;
        }
        else if (this.tabKey === CampaignTab.MATERIALS) {
            this.createOrUpdateCampaign();
        }
    };
    CampaignsDetailComponent.prototype.sendEventWhenAddingInfluencersToCampaign = function (additinalInfluencers) {
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
            id: this.campaignId,
            name: this.campaignName,
            type: TargetType.CAMPAIGN
        }, {
            action: UserActionType.UPDATE,
            actionDetails: ActionDetails.ADDED_INFLUENCERS,
            source: ActionSource.PAGE,
            influencers: additinalInfluencers
        }, undefined, {
            type: this.campaignId ? ActivePages.CAMPAIGN_EDIT : ActivePages.CAMPAIGN_NEW,
            name: this.campaignName,
            id: this.campaignId && Number(this.campaignId)
        });
    };
    CampaignsDetailComponent.prototype.handleSaveError = function (error) {
        this.modalService.open(this.serviceErrorPopup, undefined, true);
        this.serviceErrorMessage = error.error.message || error.message || error.toString();
        return Observable.throw(error);
    };
    CampaignsDetailComponent.prototype.mentionInputKeyDown = function (evt) {
        // Check if user hit Enter
        if (!evt || evt.keyCode !== 13) {
            return;
        }
        // Make sure they input something
        if (!this.currentInputMention || StringUtils.trim(this.currentInputMention) === '') {
            return;
        }
        // Determine type of mention
        var mention = this.campaignService.parseMentions(this.currentInputMention);
        // currently just use global language by default
        mention.language.push(0);
        // If we already have this mention, do nothing
        var existedMentions = this._mentions.find(function (item) { return StringUtils.trim(item.keyword).toLowerCase() === StringUtils.trim(mention.keyword).toLowerCase(); });
        if (!!existedMentions) {
            this.currentInputMention = '';
            this.mentionInput.setFocus();
            return;
        }
        // add this mention on UI
        this._mentions.push({
            id: -1,
            keyword: mention.keyword
        });
        // Clear input value
        this.currentInputMention = '';
        var activePage = {
            type: this.campaignId ? ActivePages.CAMPAIGN_EDIT : ActivePages.CAMPAIGN_NEW,
            name: this.campaignName,
            id: this.campaignId && Number(this.campaignId)
        };
        this.mentionService.processNewMention(mention, this.beforeProcessingNewMention.bind(this), this.afterProcessingNewMention.bind(this), activePage, ActionSource.PAGE);
    };
    CampaignsDetailComponent.prototype.beforeProcessingNewMention = function (mention) {
        this.canCreateOrEditCampaign = false;
        this.processingMentions.push(mention.keyword);
    };
    CampaignsDetailComponent.prototype.afterProcessingNewMention = function (data) {
        var _this = this;
        this.setDirtyData();
        this.markCampaignNotSaving();
        // if mention is not existed
        if (!data.alreadyExisted) {
            // has error during processing
            if (data.hasError) {
                // remove the processing mention
                var processingMention = this._mentions.findIndex(function (men) { return men.keyword.toLowerCase() === data.errorMention.keyword.toLowerCase(); });
                this._mentions.splice(processingMention, 1);
                // Return it to the input field
                this.currentInputMention = data.errorMention.keyword;
                this.mentionInput.setFocus();
            }
            else {
                setTimeout(function () {
                    _this.mentionInput.setFocus();
                }, 0);
                // Update the target ID in place.
                var selectdIndex = this._mentions.findIndex(function (m) { return StringUtils.trim(m.keyword.toLowerCase()) === StringUtils.trim(data.newMention.keyword.toLowerCase()); });
                this._mentions.splice(selectdIndex, 1, data.newMention); // Replace
            }
        }
        else {
            // if mention is existed
            var selectedMention = this._mentions.find(function (men) { return StringUtils.trim(men.keyword.toLowerCase()) === StringUtils.trim(data.newMention.keyword.toLowerCase()); });
            if (selectedMention) {
                selectedMention.id = data.newMention.id;
            }
        }
        // after processing all mentions
        var inProgressMentions = this._mentions.filter(function (m) { return m.id === -1; });
        if (inProgressMentions.length === 0) {
            // clear the blocker of Campaign editable
            this.canCreateOrEditCampaign = true;
            this.processingMentions = [];
        }
    };
    CampaignsDetailComponent.prototype.selectableCampaignTermsChange = function (event) {
        this.updateTabs();
    };
    CampaignsDetailComponent.prototype.uploadFileChange = function (event) {
        this.updateTabs();
        this.setDirtyData();
    };
    CampaignsDetailComponent.prototype.extractParams = function (params) {
        if (!params) {
            return null;
        }
        var result = {};
        params
            .filter(function (x) { return x.paramType !== 0 /* Str */; })
            .forEach(function (x) {
            var val = x.type === 'int' ? parseInt(x.value, 10) : x.value;
            result[x.key] = {
                value: val,
                type: x.type
            };
        });
        return result;
    };
    CampaignsDetailComponent.prototype.onDeleteMention = function (index) {
        // on Premium or Enterprise can delete mention of campaign
        if (!this.hasPermissionOnCampaign()) {
            this.userService.doInvalidActionByLevel('Campaign Disabled');
            return;
        }
        var currentMention = this._mentions[index];
        if (!currentMention) {
            return;
        }
        this.modalService.openInCenter(this.confirmRemoveMentionDialog);
        this.currentDeleteMention = currentMention;
        this.currentDeleteMentionIndex = index;
    };
    CampaignsDetailComponent.prototype.hasPermissionOnCampaign = function () {
        return this.userService.isEnterpriseAccount() || this.userService.isPremiumAccount();
    };
    CampaignsDetailComponent.prototype.parseTerm = function (term) {
        if (!term) {
            return null;
        }
        if (!term.hasParams) {
            return [{
                    content: term.summary,
                    paramType: 0 /* Str */
                }];
        }
        var match, cursor = 0;
        var termStr = term.summary, params = [];
        while (match = TermRegex.exec(termStr)) {
            params.push({
                content: termStr.substr(cursor, match.index),
                paramType: 0 /* Str */
            }, {
                key: match[1],
                paramType: 1 /* Param */,
                type: this.getParamType(match[1]),
                value: ''
            });
            cursor = match.index + match[0].length;
        }
        params.push({
            content: termStr.substr(cursor, termStr.length - cursor),
            paramType: 0 /* Str */
        });
        return params;
    };
    CampaignsDetailComponent.prototype.getParamType = function (key) {
        var inx = key.indexOf('_');
        return inx > 0 ? key.substr(0, inx) : 'string';
    };
    CampaignsDetailComponent.prototype.backToCampaigns = function () {
        this.cacheService.enableCacheRemoving();
        this.modalService.close();
        if (this.isCampaignHistory) {
            this.router.navigateByUrl('/campaigns/history');
        }
        else if (this.isCampaignInfluencer) {
            this.router.navigate(["/campaigns/" + this.campaignId + "/influencer-list"], {
                queryParams: {
                    activeAccount: this.activeAccount,
                    campaignId: this.campaignId
                }
            });
        }
        else {
            this.router.navigateByUrl('/campaigns');
        }
    };
    CampaignsDetailComponent.prototype.updateTabs = function () {
        if (this.mainTabs) {
            this.mainTabs.delayUpdate();
        }
    };
    CampaignsDetailComponent.prototype.closeErrorMessage = function () {
        this.modalService.close();
    };
    CampaignsDetailComponent.prototype.closeConfirmMessageDialog = function () {
        this.modalService.close();
    };
    CampaignsDetailComponent.prototype.contactSupport = function () {
        this.userService.contactSupport();
    };
    CampaignsDetailComponent.prototype.confirmRemoveMention = function () {
        if (!this.currentDeleteMention) {
            this.modalService.close();
            return;
        }
        this._mentions.splice(this.currentDeleteMentionIndex, 1);
        this.modalService.close();
        this.currentDeleteMention = null;
        this.currentDeleteMentionIndex = -1;
        this.setDirtyData();
    };
    CampaignsDetailComponent.prototype.backToPreviousStep = function () {
        this.cacheService.enableCacheRemoving();
        if (this.tabKey === CampaignTab.TERMS) {
            if (this.isCampaignDataChanged()) {
                // Go from Terms to Campaign Overview
                this.modalService.openInCenter(this.confirmBackToCampaignListDialog);
            }
            else {
                this.backToCampaigns();
            }
        }
        else if (this.tabKey === CampaignTab.INFLUENCER) {
            // Go from Influencers to Terms
            this.replaceTabState(CampaignTab.TERMS);
            this.tabKey = CampaignTab.TERMS;
        }
        else if (this.tabKey === CampaignTab.MATERIALS) {
            // Go from Materials to Influencers
            this.replaceTabState(CampaignTab.INFLUENCER);
            this.tabKey = CampaignTab.INFLUENCER;
        }
    };
    CampaignsDetailComponent.prototype.goToNextStep = function () {
        if (this.tabKey === CampaignTab.TERMS) {
            // Go from Terms => Influencers
            this.replaceTabState(CampaignTab.INFLUENCER);
            this.tabKey = CampaignTab.INFLUENCER;
        }
        else if (this.tabKey === CampaignTab.INFLUENCER) {
            // Go from Influencers => Materials
            this.replaceTabState(CampaignTab.MATERIALS);
            this.tabKey = CampaignTab.MATERIALS;
            return;
        }
        else if (this.tabKey === CampaignTab.MATERIALS) {
            // Save and return to Campaign Overview
            this.saveAndSend();
        }
    };
    CampaignsDetailComponent.prototype.openAddInfluencerToCampaign = function () {
        this.isShowAddInfluencerToCampaignsFragment = true;
        this.activeBottomBar = 'active';
    };
    CampaignsDetailComponent.prototype.closeAddInfluencerToCampaign = function (data) {
        this.isShowAddInfluencerToCampaignsFragment = false;
        this.activeBottomBar = 'inactive';
    };
    CampaignsDetailComponent.prototype.addMoreInfluencerToCampaign = function (additinalInfluencers) {
        var _this = this;
        this.setDirtyData();
        // clear cached selected influencer suggestions
        this.selectedInfluencerToAddCampaign = [];
        // keep the list availabel influencers
        this.pendingInfluencerListAddToCampaign = additinalInfluencers;
        // Clear the previous selections before adding new ones
        this.campaignInfluencers = this.campaignInfluencers.filter(function (ci) { return ci.campaign_influencer_status !== CampaignInfluencerStatus.NEW; });
        var alreadySelectedInflIds = this.campaignInfluencers.map(function (ci) { return ci.influencer_id; });
        // update UI
        additinalInfluencers.forEach(function (influencer) {
            if (alreadySelectedInflIds.indexOf(influencer.influencer_id) < 0) {
                _this.campaignInfluencers.push({
                    campaign_influencer_id: influencer.influencerId,
                    influencer_id: influencer.influencer_id,
                    influencer_name: influencer.influencerName,
                    campaign_influencer_status: CampaignInfluencerStatus.NEW,
                    campaign_influencer_number_of_post: 0,
                    campaign_influencer_platformBlogs: false,
                    campaign_influencer_platformInstagram: false,
                    campaign_influencer_platformYoutube: false,
                    campaign_influencer_platformSnapchat: false,
                    campaign_influencer_platformTwitter: false,
                    campaign_influencer_platformPinterest: false,
                    campaign_influencer_platformFacebook: false,
                    campaign_influencer_platformTikTok: false,
                    campaign_influencer_reach: influencer.reach,
                    campaign_influencer_engagement: influencer.engagement,
                    campaign_influencer_impact: influencer.impact,
                    influencer_profile_picture: influencer.profilePicture,
                    country_code: influencer.countryCode,
                    country: {
                        name: influencer.countryName,
                        code: influencer.countryCode
                    },
                    is_accepted: influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name
                });
            }
            else {
                var addedInfluencerIndex = _this.campaignInfluencers.findIndex(function (ci) { return ci.influencer_id === influencer.influencer_id; });
                var addAsAccepted = influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name;
                _this.campaignInfluencers[addedInfluencerIndex].is_accepted = addAsAccepted;
            }
        });
        this.closeAddInfluencerToCampaign({
            resetSelectedInfluencer: false
        });
    };
    Object.defineProperty(CampaignsDetailComponent.prototype, "numberAvailabelMaterialFile", {
        get: function () {
            return this.materialImages.filter(function (file) { return file.action !== FileAction.DELETE; }).length;
        },
        enumerable: true,
        configurable: true
    });
    CampaignsDetailComponent.prototype.warningDeleteTerm = function (termId) {
        this.selectedToDeleteCustomTermId = termId;
        this.modalService.openInCenter(this.warningDeleteCustomTermDialog);
    };
    CampaignsDetailComponent.prototype.showActiveOrArchiveCampaignPopup = function () {
        this.modalService.openInCenter(this.CampaignStatusDialog, null, 'campaign-status-dialog');
    };
    CampaignsDetailComponent.prototype.changeCampaignStatus = function () {
        var _this = this;
        this.modalService.close();
        if (this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE) {
            this.campaignArchivedAt = DateUtils.convertDateToString(new Date(), 'dd-MM-yyyy');
            this.campaignStatus = CampaignStatus.ARCHIVED;
            this.isActiveCampaign = false;
            this.isArchivedCampaign = true;
            this.campaignService.archiveCampaign(this.campaignId).subscribe(function (res) {
                _this.userService.triggerUpdateActivatedInfluencers();
            }, function (error) {
                _this.campaignErrorMsg = _this.translate.instant('campaigns.free_user_campaign_err_msg');
                _this.campaignStatus = CampaignStatus.ACTIVE;
                _this.isActiveCampaign = true;
                _this.isArchivedCampaign = false;
                _this.modalService.openInCenter(_this.CampaignErrorPopup);
            });
        }
        else {
            this.campaignStatus = CampaignStatus.ACTIVE;
            this.isActiveCampaign = true;
            this.isArchivedCampaign = false;
            this.campaignService.unarchiveCampaign(this.campaignId).subscribe(function (res) {
                _this.userService.triggerUpdateActivatedInfluencers();
            }, function (error) {
                _this.campaignStatus = CampaignStatus.ARCHIVED;
                _this.isActiveCampaign = false;
                _this.isArchivedCampaign = true;
                if (error.status === 403) {
                    _this.campaignErrorMsg = _this.translate.instant('campaigns.free_user_campaign_err_msg');
                    _this.modalService.openInCenter(_this.CampaignErrorPopup);
                }
                else {
                    var serverError = CampaignsDetailComponent.buildMessageErrorInArchive(error.error, _this.translate);
                    if (serverError.errorType === 'invalid level') {
                        _this.userService.doInvalidActionByLevel('Active Campaign', serverError.errorMsg);
                    }
                    else {
                        _this.campaignErrorMsg = serverError.errorMsg;
                        _this.modalService.openInCenter(_this.CampaignErrorPopup);
                    }
                }
            });
        }
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
            type: TargetType.CAMPAIGN,
            id: this.campaignId,
            name: this.campaignName
        }, {
            action: UserActionType.UPDATE,
            source: ActionSource.PAGE,
            actionDetails: this.campaignStatus === CampaignStatus.ARCHIVED ? ActionDetails.ARCHIVED_CAMPAIGN : ActionDetails.UNARCHIVED_CAMPAIGN
        }, undefined, undefined);
    };
    CampaignsDetailComponent.prototype.deleteCustomTerm = function () {
        var _this = this;
        this.modalService.close();
        var termId = this.selectedToDeleteCustomTermId;
        this.campaignService
            .deleteTerm(termId)
            .subscribe(function (res) {
            _this.selectableCampaignTerms = _this.selectableCampaignTerms
                .filter(function (term) { return term.id !== termId; });
        });
    };
    CampaignsDetailComponent.prototype.showModifyTerm = function (term) {
        this.selectedCustomTerm = term;
        this.isShowModifyCustomTerm = true;
        this.activeBottomBar = 'active';
    };
    CampaignsDetailComponent.prototype.modifyCustomTerm = function (term, isAddNew) {
        var _this = this;
        var isAddNewAction = isAddNew;
        var termData = new CampaignCustomTerm();
        termData = {
            campaignType: CampaignType.CREATION,
            companyId: this.userService.getCompanyId(),
            summary: term.summary,
            body: term.body,
            heading: term.heading
        };
        if (!isAddNewAction) {
            termData.id = term.id;
        }
        var errors = this.campaignService.validateCustomTerm(termData);
        if (errors.length > 0) {
            this.validateErrorHandler.shouldDisplayErrors(true);
            this.validateErrorHandler.updateErrors(errors);
        }
        else {
            if (isAddNewAction) {
                this.campaignService
                    .addCustomTerm(termData)
                    .subscribe(function (res) {
                    _this.setDirtyData();
                    _this.selectableCampaignTerms.push(res);
                    _this.closeCustomTermDetailsBottomBar();
                    _this.modalService.open(_this.alertAddCustomTermSuccess, undefined, true);
                });
            }
            else {
                this.campaignService
                    .editCustomTerm(termData, termData.id)
                    .subscribe(function (res) {
                    // set dirty data
                    _this.setDirtyData();
                    // update edited term
                    var result = res;
                    var editedTermList = _this.selectableCampaignTerms.filter(function (item) { return item.id === result.id; });
                    if (result && editedTermList) {
                        var editedTerm = editedTermList[0];
                        editedTerm.summary = result.summary;
                        editedTerm.heading = result.heading;
                        editedTerm.body = result.body;
                    }
                    _this.closeCustomTermDetailsBottomBar();
                    _this.modalService.open(_this.alertEditCustomTermSuccess, undefined, true);
                });
            }
        }
    };
    CampaignsDetailComponent.prototype.closeCustomTermDetailsBottomBar = function () {
        this.isShowModifyCustomTerm = false;
        this.activeBottomBar = 'inactive';
    };
    CampaignsDetailComponent.prototype.addNewAcceptedToCampaign = function (campaignId, influencers, errorCallback) {
        var _this = this;
        this.hasInvalidAccountLevelError = false;
        var newAcceptedInfluencers = influencers.filter(function (influencer) { return influencer.campaign_influencer_status === CampaignInfluencerStatus.NEW && influencer.is_accepted; })
            .map(function (infl) { return ({
            action: 'add',
            domain: infl.influencer_name,
            influencer_id: infl.campaign_influencer_id,
            profile_image: infl.influencer_profile_picture,
            status: CampaignInfluencerStatus.ACCEPTED
        }); });
        if (newAcceptedInfluencers.length > 0) {
            this.campaignService.addInfluencerToCampaign({
                campaign_id: campaignId,
                influencers: newAcceptedInfluencers
            }).subscribe(function () {
                _this.userService.triggerUpdateActivatedInfluencers();
                _this.router.navigateByUrl('/campaigns');
            }, function (err) {
                if (err.error.data === 'invalid_level') {
                    _this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
                    _this.sendInvalidActionToSegement(_this.groupService.extractLimitInfoFromErrorMessage(err.error.message, _this.campaignInfluencers.length, _this.userService.maxCampaignInfluencers, true), {
                        campaign_id: _this.campaignId,
                        campaign_name: _this.campaignName,
                        influencers: influencers
                    });
                }
                if (errorCallback) {
                    errorCallback();
                }
            });
        }
        else {
            this.router.navigateByUrl('/campaigns');
        }
    };
    CampaignsDetailComponent.prototype.sendInvalidActionToSegement = function (limitInfo, influencerAddToCampaign) {
        var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
        // send event when adding to Campaign
        this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
            id: this.campaignId,
            name: this.campaignName,
            type: TargetType.CAMPAIGN
        }, __assign({ action: this.campaignId > 0 ? UserActionType.UPDATE : UserActionType.CREATE, actionDetails: ActionDetails.ADDED_INFLUENCERS, source: ActionSource.ACTION_VIEW }, influencerAddToCampaign), undefined, {
            type: this.campaignId > 0 ? ActivePages.CAMPAIGN_EDIT : ActivePages.CAMPAIGN_NEW,
        });
    };
    CampaignsDetailComponent.prototype.isActiveOnPlatform = function (influencer, platformName) {
        return influencer.channels && influencer.channels.find(function (channel) { return channel.platform && channel.platform.name === platformName; }) !== undefined;
    };
    CampaignsDetailComponent.prototype.showFragmentAddInfluencerManually = function (evt) {
        this.selectedInfluencerToAddCampaign = evt.selectedInfluencers;
        this.indexInfluencerManually = evt.processingIndex;
        this.processingInfluencerSuggestion = evt.influencerSuggestion;
        this.isShowAddInfluencerManuallyFragment = true;
        this.isShowAddInfluencerToCampaignsFragment = false;
        this.addInfluencerAsAccepted = evt.addInfluencerAsAccepted;
    };
    CampaignsDetailComponent.prototype.closeFragmentAddInfluencerManually = function (influencer) {
        if (influencer) {
            this.selectedInfluencerToAddCampaign.splice(this.indexInfluencerManually, 1, influencer);
        }
        this.processingInfluencerSuggestion = null;
        this.indexInfluencerManually = null;
        this.isShowAddInfluencerToCampaignsFragment = true;
        this.isShowAddInfluencerManuallyFragment = false;
    };
    CampaignsDetailComponent.prototype.companyChangeCallback = function (companyId) {
        this.getSelectedTermCampaign(companyId);
    };
    CampaignsDetailComponent.prototype.setDirtyData = function () {
        this.isDirtyCampaignData = true;
    };
    CampaignsDetailComponent.prototype.markCampaignNotSaving = function () {
        this.isSavingCampaign = false;
    };
    CampaignsDetailComponent.prototype.modifyCampaignData = function () {
        this.setDirtyData();
    };
    Object.defineProperty(CampaignsDetailComponent.prototype, "campaignDialogHeader", {
        get: function () {
            return this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE ? this.translate.instant('campaigns.active_campaign_message_header') : this.translate.instant('campaigns.archive_campaign_message_header');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsDetailComponent.prototype, "campaignDialogContent", {
        get: function () {
            return this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE ? this.translate.instant('campaigns.archive_campaign_message_content') : this.translate.instant('campaigns.active_campaign_message_content');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignsDetailComponent.prototype, "campaignDialogButtonText", {
        get: function () {
            return this.campaignStatus && this.campaignStatus === CampaignStatus.ACTIVE ? this.translate.instant('campaigns.archive_campaign') : this.translate.instant('campaigns.activate_campaign');
        },
        enumerable: true,
        configurable: true
    });
    return CampaignsDetailComponent;
}(AbstractAchooComponent));
export { CampaignsDetailComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-detail.component.ts.pre-build-optimizer.js